import * as React from 'react'
import { LogoutPresenter } from './Logout.presenter'
import { LifecycleView } from '$views/components/utils/ConnectComponent'
import { DropdownItem } from '$views/components/DropdownMenu'

interface Props {
  presenter: LogoutPresenter
}
export interface View extends LifecycleView {}

export class LogoutView extends React.Component<Props> {
  render() {
    const { presenter } = this.props
    return (
      <DropdownItem lastItem href="#" onClick={presenter.onClick}>
        Cerrar sesión
      </DropdownItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Logout/Logout.view.tsx